export const LightThemeColors = {
  colors: {
    transparent: 'transparent',
    primary: '#6B55B6',
    accent: '#8A6F2F',
    background: '#FAF8FF',
    backgroundSecondary: '#F0ECFF',
    secondary: '#E9E2F8',
    surface: '#FFFFFF',
    surfaceSecondary: '#F7F4FD',
    border: '#D9D0EE',
    iconBackground: '#ECE6FA',
    iconColor: '#5C4AA5',
    placeholder: '#817A91',
    divider: '#E5DEF2',
    sliderBulletActive: '#6B55B6',
    sliderBulletInactive: '#DCD4F0',
    progressActive: '#6B55B6',
    progressInctive: '#E4DDF3',
    paginationActive: '#6B55B6',
    paginationInactive: '#DAD2EE',
    checkboxBorder: '#8577AD',
    checkboxBackground: '#6B55B6',
    success: '#34785F',
    error: '#9D315E',
    urgentSurface: '#F5DDE8',
    clinicalPageBackground: '#F6F7FA',
    clinicalCardBorder: '#DDE2EA',
    clinicalRowDivider: '#E8EBF0',
    clinicalConditionBorder: '#397D63',
    clinicalConditionText: '#285C49',
    clinicalOverallSurface: '#E8F1FA',
    clinicalOverallBorder: '#3977A8',
    clinicalOverallText: '#285E8B',
    clinicalOverallTrack: '#E5EAF0',
    clinicalOverallFill: '#3977A8',
    clinicalNoteSurface: '#F3DFE9',
    clinicalNoteBorder: '#A34770',
    clinicalNoteText: '#87375C',
    clinicalModerateSurface: '#E4F1EB',
    clinicalModerateText: '#256047',
    clinicalMildSurface: '#FFF0E5',
    clinicalMildText: '#91421D',
    clinicalLowSurface: '#EEEAF8',
    clinicalLowText: '#594592',
    text: '#1E1828',
    textLight: '#514A61',
    textStrong: '#171120',
    textContrast: '#FFFFFF',
  },
  gradients: {
    heatmap: ['#6B55B6', '#E5DEF2', '#9D315E'],
    predictionsText: ['#6B55B6', '#746A86', '#9D315E'],
  },
};

export const HighContrastThemeColors = {
  colors: {
    transparent: 'transparent',
    primary: '#4B2E83',
    accent: '#A85500',
    background: '#FFFFFF',
    backgroundSecondary: '#F4F0FF',
    secondary: '#ECE6FF',
    surface: '#FFFFFF',
    surfaceSecondary: '#F7F7F7',
    border: '#1F2937',
    iconBackground: '#E5DDFF',
    iconColor: '#341861',
    placeholder: '#4B5563',
    divider: '#374151',
    sliderBulletActive: '#4B2E83',
    sliderBulletInactive: '#6B7280',
    progressActive: '#4B2E83',
    progressInctive: '#6B7280',
    paginationActive: '#4B2E83',
    paginationInactive: '#6B7280',
    checkboxBorder: '#111827',
    checkboxBackground: '#4B2E83',
    success: '#006B3F',
    error: '#7A1744',
    urgentSurface: '#F5D3E0',
    clinicalPageBackground: '#FFFFFF',
    clinicalCardBorder: '#1F2937',
    clinicalRowDivider: '#374151',
    clinicalConditionBorder: '#006B3F',
    clinicalConditionText: '#004D2D',
    clinicalOverallSurface: '#FFFFFF',
    clinicalOverallBorder: '#075985',
    clinicalOverallText: '#075985',
    clinicalOverallTrack: '#D1D5DB',
    clinicalOverallFill: '#075985',
    clinicalNoteSurface: '#FFFFFF',
    clinicalNoteBorder: '#7A1744',
    clinicalNoteText: '#7A1744',
    clinicalModerateSurface: '#D9F2E6',
    clinicalModerateText: '#004D2D',
    clinicalMildSurface: '#FFE3D1',
    clinicalMildText: '#7A2E00',
    clinicalLowSurface: '#E5DDFF',
    clinicalLowText: '#341861',
    text: '#111827',
    textLight: '#1F2937',
    textStrong: '#000000',
    textContrast: '#FFFFFF',
  },
  gradients: {
    heatmap: ['#4B2E83', '#F7F7F7', '#7A1744'],
    predictionsText: ['#4B2E83', '#374151', '#7A1744'],
  },
};

export const DarkThemeColors = {
  colors: {
    transparent: 'transparent',
  },
  gradients: {},
};
